import React from "react";
import { motion } from "framer-motion";

export default function FooterSection() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/[0.06] py-12 px-6 sm:px-12"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm text-neutral-600"
        >
          &copy; {new Date().getFullYear()} Arun Mijo. All rights reserved.
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm text-neutral-600"
        >
          AI Artist &middot; AI-VFX Lead &middot; AD (VFX) &middot; Chennai,
          India
        </motion.p>
      </div>
    </footer>
  );
}
